export default __webpack_public_path__ + "static/media/2022.c36d1e31.png";